import { useIntl } from "react-intl";

import { CollapsibleCard } from "@/components/CollapsibleCard/CollapsibleCard";
import { formatCurrency } from "@/utils/currency";

type Props = {
  basePrice: number;
  baseDiscount: number;
  tourPrice?: number;
  promoCodeDiscount?: number;
  totalPrice: number;
};

export function PriceDetailsCard({
  basePrice,
  baseDiscount,
  promoCodeDiscount,
  tourPrice,
  totalPrice,
}: Props) {
  const intl = useIntl();

  return (
    <CollapsibleCard
      title={intl.formatMessage({
        id: "trips.priceDetails.title",
        defaultMessage: "Price details",
      })}
      collapsible={false}
    >
      <dl className="grid grid-cols-2 gap-2 text-sm">
        <dt className="text-text-disabled-primary">
          {intl.formatMessage({
            id: "trips.basePrice",
            defaultMessage: "Base trip price",
          })}
        </dt>
        <dd className="text-end font-bold">{formatCurrency(basePrice)}</dd>

        {tourPrice !== undefined && (
          <>
            <dt className="text-text-disabled-primary">
              {intl.formatMessage({
                id: "trips.tours.tourPrice",
                defaultMessage: "City tours",
              })}
            </dt>
            <dd className="text-end font-bold">{formatCurrency(tourPrice)}</dd>
          </>
        )}

        <dt className="text-text-disabled-primary">
          {intl.formatMessage({
            id: "trips.discount",
            defaultMessage: "Discount",
          })}
        </dt>
        <dd className="text-end font-bold">{formatCurrency(baseDiscount)}</dd>

        {promoCodeDiscount ? (
          <>
            <dt className="text-text-disabled-primary">
              {intl.formatMessage({
                id: "promoCode.promoCodeDiscount",
                defaultMessage: "Promo code discount",
              })}
            </dt>
            <dd className="text-end font-bold text-core-accent-500">
              {formatCurrency(promoCodeDiscount)}
            </dd>
          </>
        ) : null}

        <dt className="text-text-disabled-primary">
          {intl.formatMessage({
            id: "paymentMethod",
            defaultMessage: "Payment method",
          })}
        </dt>
        <dd className="text-end font-bold">
          {intl.formatMessage({ id: "qiCard", defaultMessage: "Qi" })}
        </dd>

        <dt className="text-text-disabled-primary">
          {intl.formatMessage({
            id: "trips.totalPrice",
            defaultMessage: "Total price",
          })}
        </dt>
        <dd className="text-end font-bold">{formatCurrency(totalPrice)}</dd>
      </dl>
    </CollapsibleCard>
  );
}
